export default __webpack_public_path__ + "static/media/dolor_abdominal_guardia.2829a581.pdf";